import { Paper, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Analytics, NewContactOrders } from '~/src/components/organisms'
import { Favorites } from '~/src/components/organisms/Favorites'

import { useFavorites, UseFavoritesParams, UseFavoritesResponse } from '~/src/hooks/useApi'

import {
  TypographyH2,
  TypographyH6,
  LinkToDetail,
  ViewContactOrderListPaper,
  FavoriteListPaper,
} from './Dashboard.styles'

const convert = (data: UseFavoritesResponse) =>
  data.items?.map((f) => ({
    ref: f.item?.refNo,
    name: f.item?.displayName,
    type: f.item?.stockType,
    favorites: f.count,
  }))

/**
 * Dashboard
 * @constructor
 */
export const DashboardTemplate: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [params, setParams] = useState<UseFavoritesParams>()
  const { data: favorites } = useFavorites(params)

  return (
    <>
      <Analytics />
      <ViewContactOrderListPaper>
        <TypographyH2>{t('dashboard.new_exchange_of_contact_orders')}</TypographyH2>
        <NewContactOrders />
        <TypographyH6>
          <LinkToDetail onClick={() => navigate('/admin/order/contact-order/list')}>
            {t('dashboard.view_contact_order_list')}
          </LinkToDetail>
        </TypographyH6>
      </ViewContactOrderListPaper>

      <FavoriteListPaper>
        <TypographyH2>{t('dashboard.favorite_list')}</TypographyH2>
        {favorites && (
          <Favorites
            data={convert(favorites)}
            pagination={favorites.pagination!}
            onNextPage={(v) => {
              setParams({ ...params, offset: Number(v.page) + 1 })
            }}
          />
        )}
      </FavoriteListPaper>
    </>
  )
}
